export function useContextOrThrow<T>(useInjectedState: () => T) {
  return () => {
    const context = useInjectedState();
    if (context == null) throw new Error("Please call 'useProvideContext' on the appropriate parent component.");

    return context;
  };
}
